// Types
import type { ItemType } from "pages/Accounts/Transaction/OpeningBalance/utils"

export const getOpeningBalance = (list: ItemType[], group_coa_code: string) => {
  return list.find(item => item.group_coa_code === group_coa_code && item.parent_id === -1)?.opening_balance ?? 0
}